import { render } from "./SpacedRow.vue?vue&type=template&id=8e3a4d90&scoped=true"
const script = {}

import "./SpacedRow.vue?vue&type=style&index=0&id=8e3a4d90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e3a4d90"]])

export default __exports__